import React from 'react'

import { BulkDeleteButton, Datagrid, DateField, Filter, List, NumberField, TextField, TopToolbar } from 'react-admin'

// import { QuickFilter } from 'dash/shared';

// const ServiceFilter = (props) => (
//   <Filter {...props}>
//     <SearchInput source="q" alwaysOn />
//     {/* <QuickFilter source="status" label="Customers" defaultValue={'active'} /> */}
//     {/* <QuickFilter source="status" label="Churned Customers" defaultValue={'churned'} /> */}
//   </Filter>
// )

export const ServiceList = () => (
  <List
    exporter={false}
    // filters={<ServiceFilter />}
    perPage={25}
  >
    <Datagrid rowClick="edit">
      <TextField source="name" />
      <NumberField source="accountsCount" label="Active Subscriptions" />
      <DateField source="createdAt" />
    </Datagrid>
  </List>
)
